<template>
  <div>
    <cbs-debug
      v-if="!hide"
      :context="this"
    />
  </div>
</template>

<script>
import useJwt from '@/cubus/jwt/useJwt'
import useCubus from '@/cubus/services/useCubus'
import Ripple from 'vue-ripple-directive'
import CbsDebug from '@/cubus/components/debug/CbsDebug.vue'

export default {
  name: 'CbsDataNewRecord',
  directives: {
    Ripple,
  },
  components: {
    CbsDebug,
  },
  props: {
    objectFull: {
      type: Object,
      default: null,
    },
    filter: {
      type: Object,
      default: null,
    },
    userFilter: {
      type: Object,
      default: null,
    },
    hide: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'load',
  ],
  data() {
    return {
      record: null,
      isDebug: false,
    }
  },
  computed: {
    compFilter() {
      // console.log('computedFilter', this.filter)
      return this.filter
    },
  },
  watch: {
    compFilter(newValue, oldValue) {
      // console.log('watchFilter', newValue, oldValue)
      if (newValue !== oldValue) {
        this.loadNewRecord()
      }
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.loadNewRecord()
    },
    getNewRecord() {
      this.loadNewRecord()
    },
    loadNewRecord() {
      useJwt.query({
        query: {
          method: 'newrecord',
          param: {
            objectid: this.objectFull.object.id,
            filter: this.filter,
            userfilter: this.userFilter,
          },
        },
      })
        .then(response => {
          // console.log('newRecord response', response)
          if (response.data.thread) {
            this.delayNewRecord(response.data.thread)
          } else if (response.data.error) {
            useCubus.toastError(this, response.data.error)
          }
        })
        .catch(error => {
          console.log('newRecord error', error)
          useCubus.toastError(this, error)
        })
    },
    delayNewRecord(thread) {
      setTimeout(() => this.threadNewRecord(thread), 500)
    },
    threadNewRecord(thread) {
      useJwt.query({
        token: useJwt.getCubusToken(),
        query: {
          method: 'thread',
          param: {
            threadname: thread,
          },
        },
      })
        .then(response => {
          // console.log('thread response', response)
          if (response.data.thread.status === 'done') {
            this.record = response.data.thread.result.record
            this.$emit('load', this.record)
          } else if (response.data.thread.status === 'error') {
            useCubus.toastError(this, response.data.thread.error)
          } else {
            this.delayNewRecord(thread)
          }
        })
        .catch(error => {
          console.log('thread error', error)
          useCubus.toastError(this, error)
        })
    },
  },
}
</script>

<style scoped>

</style>
